import {ShapeCommand} from '../commands.template';

export class StickerDeleteCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;

  constructor(data) {
    super(data);
    // this.firstAction = true;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const stickerVertex = this.services.graphHelperSvc
      .allStickers()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    graph.removeCells([stickerVertex], false);

    return this.executeJson(this.object);
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteNote: {
        mxKey: Number(data.mxKey)
      }
    });
  }

  public reverse() {
    super.reverse();
    this.services.stickersSvc.switchVisible(false, true);
    const graph = this.services.editorRegistrySvc.getGraph();
    const stickerVertex = this.services.shapeSpawnerSvc.createSticker(this.object);

    graph.addCell(stickerVertex, this.services.graphHelperSvc.stickerParent());

    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      createNote: {
        mxKey: Number(data.mxKey),
        text: data.text,
        position: {
          x: data.position.x,
          y: data.position.y,
          w: data.position.w,
          h: data.position.h,
          rotation: data.position.rotation
        },
        paperClass: data.paperClass,
        locked: Boolean(data.locked)
      }
    });
  }
}
